import React, { useEffect, useState } from "react";
import TagInputs from "../../inputs/TagInputs";
import { get, put } from "../../../utility/fetch";
import toast from "react-hot-toast";
import axios from "axios";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const SettingPersonalInfo = ({ nextStep, data }) => {
    const [profilePayload, setProfilePayload] = useState({
        firstName: data?.firstName || "",
        lastName: data?.lastName || "",
        gender: data?.gender || "",
        weight: data?.weight || 0,
        dateOfBirth: data?.dateOfBirth || "",
        pictureUrl: data?.pictureUrl || "",
        nin: data?.nin || "",
        stateOfOrigin: {
            label: data?.stateOfOrigin || "Select State",
            value: data?.stateOfOrigin || "",
        },
        lga: {
            label: data?.lga || "Select State",
            value: data?.lga || "",
        },
        placeOfBirth: data?.placeOfBirth || "",
        maritalStatus: data?.maritalStatus || "",
        nationality: data?.nationality || "",
    });
    const [selectedDate, setSelectedDate] = useState(
        data?.dateOfBirth 
            ? new Date(data.dateOfBirth) 
            : null
    );
   

    const [contactPayload, setContactPayload] = useState({
        stateOfResidence: {
            label: data?.stateOfResidence || "Select State",
            value: data?.stateOfResidence || "",
        },
        lgaResidence: {
            label: data?.lgaResidence || "Select State",
            value: data?.lgaResidence || "",
        },
        city: data?.city || "",
        homeAddress: data?.homeAddress || "",
        phone: data?.phoneNumber || "",
        email: data?.email || "",
        altPhone: data?.altPhone || "",
    });

    const [groupLoading, setGroupLoading] = useState(false);
    const [states, setStates] = useState([]);
    const [nationalities, setNationalities] = useState([]);
    const [lgas, setLgas] = useState([]);
    const [state, setState] = useState({
        label: data?.stateOfOrigin || "Select State",
        value: data?.stateOfOrigin || "",
    });
    const [lga, setLga] = useState({
        label: data?.lga || "Select LGA",
        value: data?.lga || "",
    });

    const getStates = async () => {
        const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/connectedhealthlabapi/api/hmo/state/list`);
        if (res?.data?.statusCode === 200) {
            let tempDoc = res?.data?.data?.map((doc) => {
                return { label: doc?.name, value: doc?.id };
            });
            tempDoc?.unshift({ label: "Select State", value: "" });
            setStates(tempDoc);
        }
    };

    const getLga = async (id) => {
        const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/connectedhealthlabapi/api/healthcareprovider/getlgasbystateid/id/${id}`);
        if (res?.data) {
            let tempDoc = res?.data?.map((doc) => {
                return { label: doc?.lga, value: doc?.id };
            });
            tempDoc?.unshift({ label: "Select LGA", value: "" });
            setLgas(tempDoc);
        }
    };

    const handleProfileChange = (field, value) => {
        if (field === "stateOfOrigin") {
            setProfilePayload({
                ...profilePayload,
                stateOfOrigin: value,
                lga: { label: "Select LGA", value: "" }, // Reset LGA when state changes
            });
            setContactPayload({
                ...contactPayload,
                stateOfResidence: value,
                lgaResidence: { label: "Select LGA", value: "" }, // Reset LGA Residence
            });
            setState(value);
            getLga(Number(value?.value));
        } else if (field === "lga") {
            setProfilePayload({ ...profilePayload, lga: value });
            setContactPayload({ ...contactPayload, lgaResidence: value });
            setLga(value);
        } else {
            setProfilePayload({ ...profilePayload, [field]: value });
        }
    };

    const handleDateChange = (date) => {
        setSelectedDate(date);
        
        if (date) {
            const formatted = date.toISOString().split('T')[0]; // "2025-01-15"
            setProfilePayload(prev => ({
                ...prev,
                dateOfBirth: formatted
            }));
        } else {
            setProfilePayload(prev => ({
                ...prev,
                dateOfBirth: ''
            }));
        }
    };

    const handleContactChange = (field, value) => {
        setContactPayload({ ...contactPayload, [field]: value });
    };

    const updateProfile = async () => {
        const response = await put(`/Patient/${data?.id}`, profilePayload);
        if (response.statusCode === 200) {
            toast.success("Profile updated successfully");
        } else {
            toast.error("Error updating profile");
        }
    };

    const updateContact = async () => {
        const response = await put(`/Patient/${data?.id}/contact-update`, contactPayload);
        if (response.statusCode === 200) {
            toast.success("Contact updated successfully");
        } else {
            toast.error("Error updating contact");
        }
    };

    const update =  () => {
        setGroupLoading(true);
         updateProfile();
         updateContact();
        setGroupLoading(false);
    };

    useEffect(() => {
        getStates();
    }, []);

    useEffect(() => {
        if (data) {
            setProfilePayload({
                firstName: data?.firstName || "",
                lastName: data?.lastName || "",
                gender: data?.gender || "",
                weight: data?.weight || 0,
                dateOfBirth: data?.dateOfBirth || "",
                pictureUrl: data?.pictureUrl || "",
                nin: data?.nin || "",
                stateOfOrigin: {
                    label: data?.stateOfOrigin || "Select State",
                    value: data?.stateOfOrigin || "",
                },
                lga: {
                    label: data?.lga || "Select State",
                    value: data?.lga || "",
                },
                placeOfBirth: data?.placeOfBirth || "",
                maritalStatus: data?.maritalStatus || "",
                nationality: data?.nationality || "",
            });
            setContactPayload({
                stateOfResidence: {
                    label: data?.stateOfResidence || "Select State",
                    value: data?.stateOfResidence || "",
                },
                lgaResidence: {
                    label: data?.lgaResidence || "Select State",
                    value: data?.lgaResidence || "",
                },
                city: data?.city || "",
                homeAddress: data?.homeAddress || "",
                phone: data?.phoneNumber || "",
                email: data?.email || "",
                altPhone: data?.altPhone || "",
            });
        }
    }, [data]);

    return (
        <div className="card p-40">
            <div className="profile-header m-b-40 flex space-between">
                <div className="flex">
                    <img src={profilePayload.pictureUrl || "user-avater.png"} alt="User" className="profile-pic" />
                    <div className="m-l-10">
                        <h3>{`${data?.fullName || ""}`}</h3>
                        <p>{data?.email}</p>
                    </div>
                </div>
                <button
                    disabled={groupLoading}
                    className="save-drafts col-3"
                    onClick={update}
                >
                    Save Changes
                </button>
            </div>

            <div className="flex space-between">
                <form className="profile-form col-6">
                    <div className="form-group">
                        <TagInputs
                            label="First Name"
                            type="text"
                            value={profilePayload.firstName}
                            onChange={(e) => handleProfileChange("firstName", e.target.value)}
                        />
                    </div>
                    <div className="form-group">
                        <TagInputs
                            label="Last Name"
                            type="text"
                            value={profilePayload.lastName}
                            onChange={(e) => handleProfileChange("lastName", e.target.value)}
                        />
                    </div>
                    <div className="form-group">
                        <TagInputs
                            label="Gender"
                            type="text"
                            value={profilePayload.gender}
                            onChange={(e) => handleProfileChange("gender", e.target.value)}
                        />
                    </div>
                    <div className="form-group">
                        <label className="block text-sm font-semibold text-gray-700 mb-2">Date of Birth</label>
                        <DatePicker
                            selected={selectedDate}
                            onChange={handleDateChange}
                            dateFormat="dd/MM/yyyy"
                            placeholderText="DD/MM/YYYY"
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            maxDate={new Date()}
                            className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-[#3c7e2d] focus:ring-2 focus:ring-[#3c7e2d] focus:ring-opacity-20 transition-all duration-300 outline-none hover:border-gray-300"
                            calendarClassName="border border-gray-200 rounded-xl shadow-xl"
                            wrapperClassName="w-full"
                        />
                    </div>
                    <div className="form-group">
                        <TagInputs
                            label="State of Origin"
                            type="R-select"
                            options={states}
                            value={profilePayload.stateOfOrigin}
                            onChange={(e) => handleProfileChange("stateOfOrigin", e)}
                        />
                    </div>
                    
                </form>
                <form className="profile-form col-6">
                    <div className="form-group">
                        <TagInputs
                            label="Place of Birth"
                            type="text"
                            value={profilePayload.placeOfBirth}
                            onChange={(e) => handleProfileChange("placeOfBirth", e.target.value)}
                        />
                    </div>
                    <div className="form-group">
                        <TagInputs
                            label="Marital Status"
                            type="text"
                            value={profilePayload.maritalStatus}
                            onChange={(e) => handleProfileChange("maritalStatus", e.target.value)}
                        />
                    </div>
                    <div className="form-group">
                        <TagInputs
                            label="Nationality"
                            type="text"
                            value={profilePayload.nationality}
                            onChange={(e) => handleProfileChange("nationality", e.target.value)}
                        />
                    </div>
                    <div className="form-group">
                        <TagInputs
                            label="Weight (kg)"
                            variation="Number"
                            value={profilePayload.weight}
                            onChange={(e) => handleProfileChange("weight", e.target.value)}
                        />
                    </div>
                    <div className="form-group">
                        <TagInputs
                            label="LGA"
                            type="R-select"
                            options={lgas}
                            value={profilePayload.lga}
                            onChange={(e) => handleProfileChange("lga", e)}
                        />
                    </div>
                   
                </form>
            </div>

            <h2>Contact Detail</h2>

            <div className="flex space-between">
                <form className="profile-form col-6">
                    <div className="form-group">
                        <TagInputs
                            label="Phone"
                            type="text"
                            value={contactPayload.phone}
                            onChange={(e) => handleContactChange("phone", e.target.value)}
                        />
                    </div>
                    <div className="form-group">
                        <TagInputs
                            label="Home Address"
                            type="text"
                            value={contactPayload.homeAddress}
                            onChange={(e) => handleContactChange("homeAddress", e.target.value)}
                        />
                    </div>
                </form>
                <form className="profile-form col-6">
                    <div className="form-group">
                        <TagInputs
                            label="Email"
                            type="text"
                            value={contactPayload.email}
                            onChange={(e) => handleContactChange("email", e.target.value)}
                        />
                    </div>
                    <div className="form-group">
                        <TagInputs
                            label="City"
                            type="text"
                            value={contactPayload.city}
                            onChange={(e) => handleContactChange("city", e.target.value)}
                        />
                    </div>
                </form>
            </div>
        </div>
    );
};

export default SettingPersonalInfo;